module.exports = __webpack_public_path__ + "img/methodology.a330eb3c.jpg";